import { formatMessageError } from "@/utils/formatMessageError";
import { App, Col, Divider, Grid, Progress, Row, Typography } from "antd";
import { useEffect, useState } from "react";

export function DadosEspacoDisco() {
  const screens = Grid.useBreakpoint();
  const [memorySpace, setMemorySpace] = useState(0);
  const { notification } = App.useApp();

  useEffect(() => {
    navigator.storage
      .estimate()
      .then((estimate) => {
        if (!estimate.usage || !estimate.quota) return;
        setMemorySpace(
          parseFloat(((estimate.usage / estimate.quota) * 100).toFixed(2)) || 0
        );
      })
      .catch((error) => {
        console.log(error);
        const messageError = formatMessageError(error);
        notification.error({
          message: "Não foi possivel calcular o uso de memória",
          description: messageError,
        });
      });
  }, []);

  return (
    <>
      <Divider>
        <Typography.Title level={screens.xs ? 5 : 4}>
          Uso do espaço em disco
        </Typography.Title>
      </Divider>
      <Row justify="center" align="middle" style={{ marginTop: 20 }}>
        <Col>
          <Progress
            type="circle"
            percent={memorySpace}
            size="default"
            status="normal"
          />
        </Col>
      </Row>
    </>
  );
}
